import React from 'react'
import './any-professional-card.css'
import { HiOutlineUsers } from "react-icons/hi";


const AnyProfessionalCard = ({ Action, Professional, Description }) => {
    return (
        <div>
            <button className='any-professional-card' onClick={Action}>

                <span className="check">✓</span>
                <span className="uncheck"></span>

                <div className="icon">
                    <HiOutlineUsers />
                </div>

                <div className="content">
                    <p className='app-little-title'>{Professional}</p>
                    <p className='app-little-text'>{Description}</p>
                </div>
            </button>
        </div>
    )
}

export default AnyProfessionalCard